import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 0;

const slice = createSlice({
  name: '$futureOrderingLimitGeneric',
  initialState,
  reducers: {
    setFutureOrderingLimitGeneric(state, action: PayloadAction<number>) {
      return action.payload;
    },
  },
});

export const { setFutureOrderingLimitGeneric } = slice.actions;
export default slice.reducer;
